import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';
import { AUDIENCE, ratingScale, recommendationQuestionnaires } from '../../../constants/recommendationQuestionnaires';
import QuestionnaireInfo from './QuestionnaireInfo';

const getQuestionsForAudience = (audience = AUDIENCE.HOUSING) => {
  const group = recommendationQuestionnaires.find((q) => q.audience === audience);
  if (!group) return [];
  return group.categories.flatMap((cat) => cat.questions.map((q) => ({ category: cat.name, question: q })));
};

const DesktopEvalVersion2 = ({ responses = {}, setResponses, classes, audience = AUDIENCE.HOUSING, displayQuestions = [] }) => {
  const componentRef = useRef();
  // Use displayQuestions prop if provided, otherwise fallback to questions from audience
  const questions =
    Array.isArray(displayQuestions) && displayQuestions.length > 0
      ? displayQuestions
      : getQuestionsForAudience(audience).map((q, idx) => ({ sl: idx + 1, ...q }));

  // Group questions by category
  const groupedQuestions = questions.reduce((acc, q) => {
    if (!acc[q.category]) acc[q.category] = [];
    acc[q.category].push(q);
    return acc;
  }, {});

  const handleRadioChange = (id, value) => {
    setResponses((prev) => ({ ...prev, [id]: value }));
  };

  return (
    <>
      <QuestionnaireInfo className={classes.formContainer} />
      <Grid container direction="row" className={classes.formContainer} style={{ textAlign: 'left', width: '85%' }}>
        <Grid container direction="row" style={{ marginTop: 30 }}>
          <Grid item xs={12} md={6} lg={6}></Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Grid container direction="row">
              {ratingScale.map((label, i) => (
                <Grid item xs={12} md={2} lg={2} align="center" key={label}>
                  <main>{label}</main>
                </Grid>
              ))}
              <Grid item xs={false} md={2} lg={2} />
            </Grid>
          </Grid>
          {Object.entries(groupedQuestions).map(([category, qs]) => (
            <React.Fragment key={category}>
              <Grid item xs={12} style={{ marginTop: 24, marginBottom: 8, display: 'flex', justifyContent: 'center' }}>
                <strong>{category.toLocaleUpperCase()}</strong>
              </Grid>
              {qs.map((q, idx) => (
                <React.Fragment key={q.question.id}>
                  <Grid item xs={12} md={6} lg={6} align="left" className={classes.question}>
                    <summary>
                      {q.sl}. {q.question.question}
                    </summary>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <Grid container direction="row">
                      <FormControl fullWidth>
                        <RadioGroup
                          row
                          aria-label={q.question.question}
                          name={`question-${q.question.id}`}
                          value={responses[q.question.id] || ''}
                          onChange={(e) => handleRadioChange(q.question.id, e.target.value)}
                        >
                          {ratingScale.map((option) => (
                            <Grid item xs={12} md={2} lg={2} align="center" className={classes.radio} key={option}>
                              <FormControlLabel value={option} control={<Radio color="default" />} label={''} />
                            </Grid>
                          ))}
                        </RadioGroup>
                      </FormControl>
                      <Grid item xs={false} md={2} lg={2} />
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

DesktopEvalVersion2.propTypes = {
  record: PropTypes.object.isRequired,
  responses: PropTypes.object.isRequired,
  setResponses: PropTypes.func.isRequired,
  recommendationText: PropTypes.string.isRequired,
  setRecommendationText: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  audience: PropTypes.string,
  formExtra: PropTypes.object,
  setFormExtra: PropTypes.func,
};

export default DesktopEvalVersion2;
